import {
  ServerError,
  AuthorizationError,
  ResourceNotFound
} from './errors'

const checkFor = (code, errors) => errors && errors.find( e => e.errorInfo.code === code)

const checkError = (error) => {
  const { networkError, graphQLErrors } = error
  if (networkError) {
    if (error.networkError.statusCode === 401) {
      // token expired
      throw new AuthorizationError()
    }
    // networkError is defined when the response is not a valid GraphQL response, e.g. the server is completely down
    throw new ServerError()
  }

  if (checkFor('server_error', graphQLErrors)) {
    throw new ServerError()
  }

  if (checkFor('authentification_error', graphQLErrors)) {
    throw new AuthorizationError()
  }

  if (checkFor('resource_not_found', graphQLErrors)) {
    throw new ResourceNotFound()
  }
}

const GraphqlErrorHandler = ({ error, children }) => {
  if (error) checkError(error)
  return children
}

export default GraphqlErrorHandler



// WEBPACK FOOTER //
// ./src/components/error_handling/GraphqlErrorHandler.js